const config = {
	baseUrl: process.env.REACT_APP_API_ROOT,
	lngCode: "ru",
	languages: ["uz", "ru"],
	theme: "light",
};

export default config;
